<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">Logs
            <button mat-raised-button class="black-btn" (click)="zipping()" style="float: right; margin-right: 58px;">DOWNLOAD ALL</button>
        </div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ag-grid-angular style="margin: 4%; width: 92%; height: 380px; cursor: pointer;" id="LIOS-GRID-SMALL"
        class="ag-theme-balham" [theme]="'legacy'" (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()"
        [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="fileNameList"
        [context]="context" (cellClicked)="onRowClick($event)" [gridOptions]="gridOptions">
    </ag-grid-angular>
</div>